
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_60808_5496)","stroke":"#4A4A4A","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M11.25 12a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5zM3.25 14a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5zM13 4.5l-8 2"}}),_c('path',{attrs:{"d":"M5 12.25V3.5l8-2v8.75"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_60808_5496"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    